import { Heading, SpotIcon } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import { useSelectedPolicy } from "data/ss-data-hooks";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";
import { formatTwoLineAddress } from "utils";

import { TingContext, type TingContextState } from "./ting-flow";
import styles from "./ting-offer.module.scss";

export const PolicyConfirmation = () => {
  const { data } = useSelectedPolicy();
  const { formNavigate } = useMultiStepFormState<TingContextState>(TingContext);

  if (!data?.propertyAddress) {
    return null;
  }

  const { lineOne, lineTwo } = formatTwoLineAddress(data.propertyAddress, true);

  return (
    <MultiStepFormLayout
      step={1}
      totalSteps={4}
      heading="Confirm your address"
      subheading="This program is only available for the property associated with your policy."
      buttonProps={{
        primary: { path: "../contact-information" },
        cancel: { path: "/my/property-services/ting-offer" },
        promptOnCancel: true,
        formNavigate,
      }}
    >
      <div className={styles.iconItem}>
        <SpotIcon name="Home" appearance="bold" />
        <div>
          <Heading size="sm">{lineOne}</Heading>
          <Heading size="sm">{lineTwo}</Heading>
          <div className={styles.subtext}>
            Policy number: {data?.platformPolicyId}
          </div>
        </div>
      </div>
    </MultiStepFormLayout>
  );
};
